import { useTypedParams } from '@sorare/routing';

import { CollectionLayout } from '#src/components/collections/CollectionLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

const MyClubSlugCollectionLayout = () => {
  const { slug, collection } = useTypedParams<LayoutParams>();
  return (
    <CollectionLayout collection={collection} userSlug={slug} fromMyClub />
  );
};

export default MyClubSlugCollectionLayout;
